import script from "./Swiper.vue?vue&type=script&setup=true&lang=js"
export * from "./Swiper.vue?vue&type=script&setup=true&lang=js"

import "./Swiper.vue?vue&type=style&index=0&id=ea21dd28&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea21dd28"]])

export default __exports__